import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import HeaderBase, {
  LogoLink as LogoLinkBase,
  NavLinks,
  NavLink as NavLinkBase,
  PrimaryLink as PrimaryLinkBase
} from "../headers/light.js";
import { Container as ContainerBase, ContentWithVerticalPadding, Content2Xl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import logoImageSrc from "images/custom/logo.png";
// import houseImageSrc from "images/custom/house-image.svg";
import underConstructionImage from "images/custom/under-construction.jpg";

const PrimaryBackgroundContainer = tw.div`relative -mx-8 px-8 bg-primary-900 text-gray-100`;
const Header = tw(HeaderBase)`max-w-none -mt-8 py-8 -mx-8 px-8`;
const NavLink = tw(NavLinkBase)`lg:text-gray-100 lg:hocus:text-gray-300 lg:hocus:border-gray-100`;
const LogoLink = tw(LogoLinkBase)`text-gray-100 hocus:text-gray-300`;
const PrimaryLink = tw(PrimaryLinkBase)`shadow-raised lg:bg-primary-400 lg:hocus:bg-primary-500`;

const Container = tw(ContainerBase)``;
const Row = tw.div`flex items-center flex-col lg:flex-row`;
const Column = tw.div`lg:w-1/2`;
const TextColumn = tw.div`text-center lg:text-left`;
const IllustrationColumn = tw(Column)`mt-16 lg:mt-0 lg:ml-16`;
const Heading = tw(SectionHeading)`max-w-3xl lg:max-w-4xl lg:text-left leading-tight`;
const Description = tw(SectionDescription)`mt-4 max-w-2xl text-gray-100 lg:text-base mx-auto lg:mx-0`;
const PrimaryButton = tw(PrimaryButtonBase)`mt-8 text-sm sm:text-base px-6 py-5 sm:px-10 sm:py-5 bg-primary-400 inline-block hocus:bg-primary-500`;
const Image = tw.img`w-144 ml-auto`

export default ({
  heading = "Make Your Place New with HB General Contractors",
  description = "We fix up homes and offices in Toronto just how you like it. Need fresh paint, strong floors, or a whole new room? We’re here for you. Quick, quality work every time. Want to start?",
  primaryButtonText = "Get a Quote",
  primaryButtonUrl = "/contact-us",
  imageSrc = null,
}) => {
  const logoLink = (
    <LogoLink href="/">
      <img src={logoImageSrc} alt="Logo" />
      HB General Contractors
    </LogoLink>
  );
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/commercial-services">COMMERCIAL</NavLink>
      <NavLink href="/residential-services">RESIDENTIAL</NavLink>
      <div style={{ borderRight: "2px solid rgb(226, 232, 240)", display: "inline" }}></div>
      <NavLink href="/about-us">ABOUT US</NavLink>
      <PrimaryLink href="/contact-us">GET A QUOTE</PrimaryLink>
    </NavLinks>
  ];
  return (
    <PrimaryBackgroundContainer style={{ backgroundImage: `url(${underConstructionImage})`, backgroundSize: "cover", backgroundPositionY: "center", minHeight: "100vh" }}>
      <div style={{ background: "rgba(0, 0, 0, 0.7)", position: "absolute", inset: "0" }}></div>
      <Content2Xl style={{ position: "relative", zIndex: "2" }}>
        <Header logoLink={logoLink} links={navLinks} />
        <Container>
          <ContentWithVerticalPadding>
            <Row>
              <TextColumn>
                <Heading>{heading}</Heading>
                <Description>{description}</Description>
                <PrimaryButton as="a" href={primaryButtonUrl}>{primaryButtonText}</PrimaryButton>
              </TextColumn>
              <IllustrationColumn>
                <Image src={imageSrc} />
              </IllustrationColumn>
            </Row>
          </ContentWithVerticalPadding>
        </Container>
      </Content2Xl>
    </PrimaryBackgroundContainer>
  );
};
